import React from 'react';
import { FiArrowDown, FiInstagram, FiTwitter, FiGithub } from 'react-icons/fi';

import '../styles/landing.css';

import ProjectBox from '../containers/project-box';

import iconImg from '../images/icon.jpg';

import bankManagementProjectPrint from '../images/projects/BankManagementSystem.jpg';
import portifolioPrint from '../images/projects/PortfolioPrint.jpg';
import gitMenuCLIPrint from '../images/projects/GitMenuCLI.png';
import telefonicList from '../images/projects/AgendaTelefonica.jpg';

function Landing() {
    return (
        <div id="container">
            <div id="name-holder">
                <div id="social-media">
                    <a href="https://www.instagram.com/deividprocopio/" target="_blank" rel="noopener noreferrer">
                        <FiInstagram size={40} color="#000" />
                    </a>
                    <a href="https://twitter.com/Fukubi5" id="twittericon" target="_blank" rel="noopener noreferrer">
                        <FiTwitter size={40} color="#000" />
                    </a>
                    <a href="https://github.com/Fukubi" target="_blank" rel="noopener noreferrer">
                        <FiGithub size={40} color="#000" />
                    </a>
                </div>
                <img src={iconImg} alt="Icon" id="user-icon" />
                <h1>OLÁ, MEU NOME É DEIVID</h1>
                <h2>BEM VINDO AO MEU PORTFÓLIO</h2>
                <hr style={{ width: "50%", borderColor: "#000", background: "#000" }}></hr>
                <h2 style={{ marginTop: 5 }}>DESENVOLVEDOR | ESTUDANTE</h2>

                <a href="#content-display" id="content-display-link">
                    <FiArrowDown size={50} color="rgba(0, 0, 0)" />
                </a>
            </div>

            <div id="content-display">
                <h1 id="header">PROJETOS E OUTROS FEITOS POR MIM</h1>

                <div id="projects">
                    <ProjectBox
                        src={portifolioPrint}
                        alt="project"
                        title="Portfolio"
                        description="Portfolio feito para compartilhar os projetos e eventos que eu achar interessante :)"
                        projectLink="https://github.com/Fukubi/BankManagement"
                        linkName="Código fonte e download do projeto"
                        haveLink={false} />

                    <ProjectBox
                        src={bankManagementProjectPrint}
                        alt="project"
                        title="Bank Management Simulator"
                        description="Um programa que simula ações padrão em uma conta bancaria"
                        projectLink="https://github.com/Fukubi/BankManagement"
                        linkName="Código fonte e download do projeto"
                        haveLink={true} />

                    <ProjectBox
                        src={gitMenuCLIPrint}
                        alt="project"
                        title="GIT Menu CLI"
                        description="Uma CLI (Command Line Tool) para usar o Git sem precisar decorar todos os comandos"
                        projectLink="https://github.com/Fukubi/git-menu-cli"
                        linkName="Código fonte e download do projeto"
                        haveLink={true} />

                    <ProjectBox
                        src={telefonicList}
                        alt="project"
                        title="Agenda Telefônica"
                        description="Uma agenda telefônica feita em python"
                        projectLink="https://github.com/Fukubi/TelefonicList"
                        linkName="Código fonte e download do projeto"
                        haveLink={true} />
                </div>
            </div>
        </div>
    );
}

export default Landing;